export enum ApiMode {
  Online,
  Offline,
  Lazy,
  OnlineSave
}
